import React from 'react';
import { motion } from 'framer-motion';
interface ButtonProps {
  children: React.ReactNode;
  className?: string;
  onClick?: () => void;
  href?: string;
}
export function Button({
  children,
  className = '',
  onClick,
  href
}: ButtonProps) {
  const sharedClasses = `
    inline-block text-center bg-amber-500 hover:bg-amber-400 text-navy-900 
    font-bold py-4 px-8 rounded-xl shadow-glow 
    transition-colors duration-300 w-full md:w-auto
    text-lg md:text-xl uppercase tracking-wide
    ${className}
  `;
  if (href) {
    return <motion.a href={href} target="_blank" rel="noopener noreferrer" onClick={() => onClick?.()} whileHover={{
      scale: 1.02
    }} whileTap={{
      scale: 0.98
    }} className={sharedClasses} data-id="element-14">
        {children}
      </motion.a>;
  }
  return <motion.button whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} onClick={onClick} className={sharedClasses} data-id="element-15">
      {children}
    </motion.button>;
}